import React from 'react';
import styled from '@emotion/styled';
import { Button, Modal } from 'semantic-ui-react';

const ColorModal = ({ title, color, close }) => {
  return (
    <Modal onClose={close} open={!!color}>
      <Modal.Header>
        {title !== color ? `${title} - ` : ''}
        {color}
      </Modal.Header>
      <Modal.Content>
        <Color color={color} />
      </Modal.Content>
      <Modal.Actions>
        <Button content="Done" onClick={close} />
      </Modal.Actions>
    </Modal>
  );
};

const Color = styled.div(({ color }) => ({
  backgroundColor: color,
  width: '100%',
  height: 500,
}));

export default ColorModal;
